import { CircularProgress } from '@hyperflake/react-ui-library';
import { BackButton } from '@library/buttons';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import useFloorPlanLayoutContext from 'modules/shared/layouts/FloorPlanLayout/hooks/use-floor-plan-layout-context';
import EditFloorPlan from 'modules/site-walk/components/EditFloorPlan/EditFloorPlan';

const EditFloorPlanPage = () => {
    const { floorPlan, isFloorPlanQueryLoading } = useFloorPlanLayoutContext();

    if (isFloorPlanQueryLoading)
        return (
            <div className="mt-6 flex justify-center items-center min-h-[600px]">
                <CircularProgress />
            </div>
        );

    return (
        <PageTemplate>
            <PageHeading>
                <div>
                    <div>Edit Floor Plan</div>
                    <BackButton className="mt-2" />
                </div>
            </PageHeading>

            <EditFloorPlan floorPlan={floorPlan} />
        </PageTemplate>
    );
};

export default EditFloorPlanPage;
